(() => {
  function initHub(root) {
    if (!root || root.dataset.finderReady === 'true') return;
    root.dataset.finderReady = 'true';

    const input = root.querySelector('.rep-parts-hub__search');
    const status = root.querySelector('.rep-parts-hub__search-status');
    const panels = [...root.querySelectorAll('[data-hub-panel]')];
    const seriesButtons = [...root.querySelectorAll('[data-hub-target]')];
    const toggles = [...root.querySelectorAll('.rep-parts-hub__mobile-toggle')];
    const models = [...root.querySelectorAll('[data-hub-model]')];
    const archive = root.querySelector('.rep-parts-hub__archive');
    const mobile = window.matchMedia('(max-width: 767px)');
    const normalize = value => (value || '').toLocaleLowerCase('de-DE').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();

    function collapsePanels() {
      panels.forEach(panel => {
        panel.classList.remove('is-active');
        const toggle = panel.querySelector('.rep-parts-hub__mobile-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
      seriesButtons.forEach(button => button.setAttribute('aria-selected', 'false'));
    }

    function restoreDefaultView() {
      if (mobile.matches) {
        collapsePanels();
      } else if (panels.length) {
        activatePanel(panels[0].id);
      }
    }

    function activatePanel(id, allowClose = false) {
      const target = panels.find(panel => panel.id === id);
      if (!target) return;
      const closeTarget = allowClose && target.classList.contains('is-active');
      panels.forEach(panel => {
        const active = panel === target && !closeTarget;
        panel.classList.toggle('is-active', active);
        const toggle = panel.querySelector('.rep-parts-hub__mobile-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', active ? 'true' : 'false');
      });
      seriesButtons.forEach(button => {
        button.setAttribute('aria-selected', button.dataset.hubTarget === id && !closeTarget ? 'true' : 'false');
      });
    }

    function filterModels(rawQuery) {
      const query = normalize(rawQuery);
      root.classList.toggle('is-searching', query.length > 0);
      let matches = 0;
      models.forEach(model => {
        const match = !query || normalize(model.dataset.search).includes(query);
        model.hidden = !match;
        if (query && match) matches++;
      });

      panels.forEach(panel => {
        const hasMatch = !query || !!panel.querySelector('[data-hub-model]:not([hidden])');
        panel.classList.toggle('is-active', query ? hasMatch : false);
        const toggle = panel.querySelector('.rep-parts-hub__mobile-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', query && hasMatch ? 'true' : 'false');
      });

      if (archive && query) archive.open = !!archive.querySelector('[data-hub-model]:not([hidden])');
      if (!query && panels.length) {
        restoreDefaultView();
      }
      if (status) {
        status.textContent = query
          ? (matches === 1 ? '1 passendes Modell gefunden' : `${matches} passende Modelle gefunden`)
          : '';
      }
    }

    seriesButtons.forEach(button => button.addEventListener('click', () => {
      if (input && input.value) {
        input.value = '';
        filterModels('');
      }
      activatePanel(button.dataset.hubTarget);
    }));
    toggles.forEach(toggle => toggle.addEventListener('click', () => {
      const panel = toggle.closest('[data-hub-panel]');
      if (panel) activatePanel(panel.id, true);
    }));

    if (input) {
      input.addEventListener('input', event => filterModels(event.target.value));
      input.addEventListener('keydown', event => {
        if (event.key === 'Escape' && input.value) {
          input.value = '';
          filterModels('');
        }
      });
    }
    if (mobile.addEventListener) {
      mobile.addEventListener('change', () => {
        if (!root.classList.contains('is-searching')) restoreDefaultView();
      });
    }
    root.classList.add('is-enhanced');
    restoreDefaultView();
  }

  function initAll(scope = document) {
    if (scope.matches && scope.matches('[data-rep-parts-hub]')) initHub(scope);
    scope.querySelectorAll && scope.querySelectorAll('[data-rep-parts-hub]').forEach(initHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
